(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class PartnerLogosLoop {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-partner-logos-track]');
      if (!this.track) return;

      this.baseItems = Array.from(this.track.querySelectorAll('[data-partner-logo-item]')).filter(
        (item) => !item.classList.contains('partner-logos__item--clone')
      );
      if (!this.baseItems.length) return;

      this.sync = this.sync.bind(this);
      this.init();
    }

    init() {
      if (prefersReducedMotion.matches) {
        this.cleanupClones();
        this.section.style.removeProperty('--partner-logos-loop-distance');
        return;
      }

      this.sync();
    }

    cleanupClones() {
      this.track.querySelectorAll('[data-generated-clone="true"]').forEach((node) => node.remove());
    }

    sync() {
      this.cleanupClones();

      const baseWidth = this.baseItems.reduce((total, item) => total + item.getBoundingClientRect().width, 0);
      if (!baseWidth) return;

      this.section.style.setProperty('--partner-logos-loop-distance', `-${baseWidth}px`);

      const viewport = this.section.querySelector('[data-partner-logos-viewport]');
      if (!viewport) return;

      const minTrackWidth = viewport.getBoundingClientRect().width + baseWidth;
      let currentWidth = this.track.scrollWidth;

      while (currentWidth < minTrackWidth) {
        const fragment = document.createDocumentFragment();
        this.baseItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.dataset.generatedClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea').forEach((focusable) => {
            focusable.setAttribute('tabindex', '-1');
            focusable.setAttribute('aria-hidden', 'true');
          });
          fragment.appendChild(clone);
        });
        this.track.appendChild(fragment);
        currentWidth = this.track.scrollWidth;
      }
    }
  }

  const instances = new WeakMap();

  const initPartnerLogos = (root = document) => {
    root.querySelectorAll('[data-partner-logos]').forEach((section) => {
      const instance = new PartnerLogosLoop(section);
      if (instance.track) {
        instances.set(section, instance);
      }
    });
  };

  const syncAll = () => {
    document.querySelectorAll('[data-partner-logos]').forEach((section) => {
      instances.get(section)?.sync();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPartnerLogos(document));
  } else {
    initPartnerLogos(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPartnerLogos(event.target);
  });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(syncAll, 150);
  });

  if (typeof prefersReducedMotion.addEventListener === 'function') {
    prefersReducedMotion.addEventListener('change', () => {
      syncAll();
    });
  }
})();
